import { createContext } from "react";

export interface DeleteAccountDialogContextType {
  open: () => void;
  close: () => void;
  isOpen: boolean;
}

export const DeleteAccountDialogContext =
  createContext<DeleteAccountDialogContextType | null>(null);
